import React, { useState, useEffect } from 'react';
import cn from 'classnames';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';

import { Text, Heading, Loading } from 'components/common/Elements/Elements';
// import { LineFA, AreaFA } from 'components/common/charts/charts';
import { LineFA } from 'components/common/charts/charts';

import { featuresFormater } from 'utils/featuresFormater';
import { charts, zeroFeatures } from '../../helpers/configurates';
import { postRequest } from 'utils/requests';

import classes from './ChartBox.module.scss';
import colors from 'components/common/charts/helpers/colorsNew.module.scss';

const ChartBox = ({ features = [] }) => {
  const { t } = useTranslation(['activity']);

  const [chart, setChart] = useState(charts.chart[0]);
  const [chartData, setChartData] = useState([]);
  const [chartLoader, setChartLoader] = useState(true);
  const [show, setShow] = useState(false);

  const handleUnit = e => {
    setShow(false);
    setChart(e.target.value);
  };

  useEffect(() => {
    let cancelled = false;
    setChartLoader(true);
    const REQ_BODY = {
      chartName: chart,
      featureAdoption: features.length === 0 ? '*' : features
    };
    postRequest('/product/fa/chart', REQ_BODY)
      .then(res => {
        if (!cancelled) {
          setChartData(res.body);
          setShow(true);
        }
      })
      .catch(err => {
        !cancelled && console.log(err);
      });
    setChartLoader(false);
    return () => (cancelled = true);
  }, [chart, features]);

  return (
    <section className={classes.box}>
      <Heading size={2} className={classes.visually_hidden}>
        {t('activity:features.CHARTS')}
      </Heading>
      <div className={classes.list}>
        {charts.chart.map((item, ind) => {
          return (
            <label
              key={item}
              className={cn(classes.item, chart === item && classes.active)}
            >
              <Text size={4} className={classes.item_text}>
                {charts.chartLabel[ind]}
              </Text>
              <input
                className={classes.visually_hidden}
                type="radio"
                name="charts"
                value={item}
                onChange={handleUnit}
                checked={chart === item}
              />
            </label>
          );
        })}
      </div>
      <div className={classes.chart}>
        {chartLoader || chartData.length === 0 ? (
          <Loading />
        ) : (
          <>
            {/*   {chart === charts.chart[0] && (     // commented wait fo BI data
               <AreaFA chartData={chartData} show={show} />
             )} */}
            {chart === charts.chart[0] && ( // changed to 0 back to 1 if Time to Adoption will be back
              <LineFA chartData={chartData} show={show} />
            )}
          </>
        )}
      </div>

      <ul className={classes.legend}>
        {features.length > 0
          ? features.map((feature, ind) => {
              return (
                <li
                  key={feature}
                  className={cn(classes.feature, colors[`color${ind}`])}
                >
                  {featuresFormater(feature, t)}
                </li>
              );
            })
          : zeroFeatures.map((feature, ind) => {
              return (
                <li
                  key={feature}
                  className={cn(classes.feature, colors[`color${ind}`])}
                >
                  {featuresFormater(feature, t)}
                </li>
              );
            })}
      </ul>
    </section>
  );
};

ChartBox.propTypes = {
  features: PropTypes.arrayOf(PropTypes.string)
};

export default ChartBox;
